export const USER_AUTH_STATE_AUTHENTICATED = 'authenticated';
export const USER_AUTH_STATE_ANONYMOUS = null;
